import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(true)

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
    
        const handleMediaChange = (e) => {
            setActive(e.matches);
        };
    
        handleMediaChange(mediaQuery);
    
        mediaQuery.addEventListener("change", handleMediaChange);
    
        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);

    return (
        <li class={`ns-sidebar-dropdown pd-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-2"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-color-black ns-font-5 pd-text-uppercase">{facet.name}</span>
                {/* {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
